import { render, staticRenderFns } from "./SteamDetails.vue?vue&type=template&id=b34347ca&"
import script from "./SteamDetails.vue?vue&type=script&lang=js&"
export * from "./SteamDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports